import React from 'react';
import { connect } from 'react-redux';
import { updateWorkSamplesLocal } from 'registration/creative/ducks';
import WritingSamplesUpload from 'registration/creative/components/writing_samples_upload';

const mapStateToProps = ({user, creativeRegistration: {workSamples}}) => ({
  user,
  samples: workSamples
})

export default connect(mapStateToProps, {
  updateLocal: updateWorkSamplesLocal
})(WritingSamplesUpload);



// WEBPACK FOOTER //
// ./registration/creative/containers/writing_samples_upload.jsx